/**
 * The public sign-in configuration, read once per session.
 *
 * A failed read is reported as "nothing configured" by the callers, which hides the
 * Telegram and Google paths: a button that cannot work is worse than no button, and the
 * email form still signs someone in.
 */
import { useQuery } from "@tanstack/react-query";

import { authApi, type AuthConfig } from "@/api/auth";
import { queryKeys } from "@/api/queryKeys";

const NOT_CONFIGURED: AuthConfig = { telegram_bot_username: "", google_client_id: "" };

export function useAuthConfig(): { telegramBot: string; googleClientId: string; isPending: boolean } {
  const query = useQuery({
    queryKey: queryKeys.auth.config(),
    queryFn: authApi.config,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });
  const config = query.data ?? NOT_CONFIGURED;
  return {
    telegramBot: config.telegram_bot_username,
    googleClientId: config.google_client_id,
    isPending: query.isPending,
  };
}
